import axios from "axios";

// const BACKEND_URL = "www.rivetrading.com:81/api";
const BACKEND_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:5000"
    : process.env.REACT_APP_QST_BACKEND_URL + "/api";
const SOCKET_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:5001"
    : process.env.REACT_APP_SOCKET_URL;
const QST_API = "wss://127.0.0.1:8888/websocket";

async function postDataNoRefresh(url, data) {
  try {
    const tmpAPI = axios.create({ baseURL: BACKEND_URL });
    const response = await tmpAPI.post(`${api.BACKEND_URL}/${url}`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const api = {
  QST_API,
  BACKEND_URL,
  SOCKET_URL,
  postDataNoRefresh,
};
